module.exports = __webpack_public_path__ + "img/picto-revenu.ed319ba4.svg";